import { useMemo } from 'react';
import { SortOption } from '../AccommodationsConsole.types';
import { useTranslation } from '@shared/core';
import { useAccommodationsConsoleConfig } from '../AccommodationsConsoleConfigContext';

export const useSortOptions = () => {
  const { t } = useTranslation('accommodationsConsole');
  const sortTrans = t('sort');
  const config = useAccommodationsConsoleConfig();

  const sortOptionsMap = useMemo(() => new Map(config.listingsPanel.sortConfig.sortOptions), [config.listingsPanel.sortConfig.sortOptions]);

  const sortOptions = useMemo(() => Array.from(sortOptionsMap.entries()).map(([value, label]) => ({ value, label })), [sortOptionsMap]);

  const getSelectedOptionLabel = (selectedValue: SortOption) => {
    return sortOptionsMap.get(selectedValue) || sortTrans.couplesPicks();
  };

  return {
    sortOptions,
    getSelectedOptionLabel,
    sortTrans,
  };
};
